<template><div><h1 id="portoberechnung-positionen" tabindex="-1"><a class="header-anchor" href="#portoberechnung-positionen"><span>Portoberechnung Positionen</span></a></h1>
<p>Portoberechnung Positionen — Preisstaffelung zu Portoberechnung für Web-Anwendungen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Diese Tabelle bildet die Preisstaffelung zur <RouteLink to="/referenz/refs/ft.refdata.portoberechnung.html" title="Versandkosten-Berechnung">Portoberechnung</RouteLink> ab.</p>
<p>Diese Berechnung funktioniert nur mit dem Web-Service CheckOrder für Internetanwendungen!</p>
<p>Pfad: <code v-pre>Verkauf → Tabellen → Versandkosten-Berechnung (FTML/BEI)</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Anzahl Artikel</dt>
<dd>Anzahl Artikel</dd>
<dt>Gesamtgewicht</dt>
<dd>Gesamtgewicht aller im Auftrag enthaltenen Artikel.</dd>
<dt>Preis</dt>
<dd>Der in der Artikelmaske einegatragene Preis des Portoartikels wird mit diesem Betrag überschieben.</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>N/A</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.portoberechnung.html" title="Versandkosten-Berechnung">Portoberechnung</RouteLink></p>
</div></template>


